{
    "Page_Title": "Ações do administrador",
    "Action_Label_MC": "Efetuar chamada",
    "Action_Label_MCC": "Consultar chamada",
    "Action_Label_MDT": "Discar tom DTMF",
    "Action_Label_CC": "Libertar chamada (via controlo de chamadas)",
    "Action_Label_CCCM": "Libertar ligação (Via Modelo de Chamada)",
    "Action_Label_CX": "Libertar ligação",
    "Action_Label_AC": "Atender chamada",
    "Action_Label_HD": "Chamada em espera",
    "Action_Label_PC": "Parquear Chamada",
    "Action_Label_RC": "Recuperar chamada",
    "Action_Label_ATC": "Alternar chamada",
    "Action_Label_PUC": "Capturar chamada",
    "Action_Label_TO": "Transferência num passo",
    "Action_Label_TR": "Transferência concluída",
    "Action_Label_DF": "Desviar Chamada",
    "Action_Label_MONC": "Monitorizar a ligação",
    "Action_Label_REC": "Gravar chamada",
    "Action_Label_CBMSG": "Registe o devolução de chamada",
    "Action_Label_CO": "Participe na Conferência",
    "Action_Label_MES": "Iniciar a monitorização",
    "Action_Label_MEP": "Parar a monitorização",
    "Action_Label_SDND": "Definir estado do DNS",
    "Action_Label_SACD": "Definir estado ACD",
    "Action_Label_SFWD": "Definir estado de encaminhamento",
    "Action_Label_SACC": "Definir código da conta",
    "Action_Label_SPWD": "Definir palavra-passe da entidade",
    "Action_Label_QDND": "Consultar o estado de Não Incomodar",
    "Action_Label_QACD": "Consultar o estado do ACD",
    "Action_Label_QFWD": "Estado de encaminhamento da consulta",
    "Action_Label_SPC": "Chamada instantânea",
    "Action_Label_SPD": "Dispositivo de captura",
    "AcdOption_SignIn": "Entrar",
    "AcdOption_SignOut": "Sair",
    "AcdOption_Available": "Disponível",
    "AcdOption_NotAvailable": "Indisponível",
    "AcdOption_AlertingAcd": "Alerta (ACD)",
    "AcdOption_AlertingNonAcd": "Alerta (Não ACD)",
    "AcdOption_BusyAcd": "Ocupado (ACD)",
    "AcdOption_BusyNonAcd": "Ocupado (Não ACD)",
    "AcdOption_BusySupervisor": "Ocupado (Supervisor)",
    "AcdOption_AcdDnd": "ACD-DND (Não Incomodar)",
    "AcdOption_WrapUp": "Wrap-up",
    "ForwardOption_None": "Nenhum",
    "ForwardOption_Immediate": "Imediato",
    "ForwardOption_OnBusy": "Ocupado",
    "ForwardOption_NoAnswer": "Não atende",
    "ForwardOption_OnDnd": "DND (Não Incomodar)",
    "ForwardOption_OnOos": "Em OOS",
    "Field_Label_DeviceMain": "Dispositivo",
    "Field_Label_Destination": "Destino",
    "Field_Label_CallIDMain": "ID de chamada ativo",
    "Field_Label_DestinationAutoPrefix": "Prefixo de destino automático?",
    "Field_Label_CallIDHeld": "Outro ID de chamada",
    "Field_Label_DTMFTones": "Tons DTMF",
    "Field_Label_ParkLocation": "Localização do parqueamento",
    "Field_Label_OtherCallID": "Outro ID de chamada",
    "Field_Label_DeviceToPickupAt": "Dispositivo para capturar em",
    "Field_Label_CallParked": "Chamada parqueada",
    "Field_Label_MonitorType": "Tipo de monitorização",
    "Field_Label_Password": "Palavra-passe",
    "Field_Label_UseSecurePassword": "Usar palavra-passe segura?",
    "Field_Label_MonitorCrossRefID": "ID de referência cruzada da monitorização",
    "Field_Label_IsDND": "Ativar\/Desativar o modo DND (Não Incomodar)",
    "Field_Label_AgentID": "ID do agente",
    "Field_Label_ACDGroup": "Grupo ACD",
    "Field_Label_ACDStateReasonTextID": "ID do texto ACDStateReason",
    "Field_Label_ACDStatus": "Estado ACD",
    "Field_Label_ForwardMode": "Estado de encaminhamento",
    "Field_Label_AccountCode": "Código da conta",
    "Field_Label_PasswordOld": "Palavra-passe Antiga",
    "Field_Label_PasswordNew": "Nova Palavra-passe",
    "Field_Label_TelephonyServer": "Servidor de telefonia",
    "Field_Label_Partition": "Partição",
    "Field_Label_CME": "CME",
    "Action_Button_Label_Execute": "Executar",
    "Action_Button_Label_Reset": "Reiniciar",
    "NAME": "AdminActionsLanguage",
    "Action_Label": "Ação",
    "Action_Label_GUC": "Obtenha a Política de Conformidade do utilizador",
    "Action_Label_AAP": "Aplicar a Política de Captura da Akixi",
    "Action_Label_QPS": "Consultar o estado de presença",
    "Action_Label_DUP": "Política de Remoção de utilizador",
    "Action_Label_GT": "Obter Tenant",
    "Action_Label_DT": "Remover Tenant",
    "Action_Label_GU": "Obter utilizadores",
    "Action_Label_GVA": "Obter aplicações de voz",
    "Field_Label_SilentMonitor": "Monitorização silenciosa",
    "Field_Label_ForcedIntrude": "Entrada forçada",
    "Field_Label_Policies": "Políticas"
}